import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const interestApi = {
  createInterest: (data) => {
    return request({
      url: '/indicated_interest/create/',
      method: 'POST',
      data,
    });
  },
  getClientList: (params) => {
    return request({
      url: `/indicated_interest/list/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },
  statisticList: (params={}) => {
    return request({
      url: `/indicated_interest/statistic/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },
};
